// Body-shape illustration PNGs.
//
// Imported via Vite's asset pipeline with `assetsInlineLimit` set
// large enough to inline every PNG as base64 directly into the JS
// bundle (see vite.config.ts and vite.storefront.config.ts). This
// makes the body profile wizard render the illustrations
// instantaneously — no separate HTTP requests, no cache misses, no
// CORP/CORS surface to manage when the SDK is embedded in
// third-party storefronts. The bundle gets bigger but the runtime
// experience matches the original "drop-the-SDK-in-and-it-just-works"
// promise.
//
// The 18 PNGs live alongside this file in the SDK repo. Backend
// copies under `primeStyleAI-backend/public/assets/body-shapes/`
// stay around as a fallback for legacy bundles published before
// 5.7.10, but new bundles never reach for them.

import wStomachFlatPng from "./w-stomach-flat.png";
import wStomachAveragePng from "./w-stomach-average.png";
import wStomachRoundPng from "./w-stomach-round.png";
import wSeatFlatPng from "./w-seat-flat.png";
import wSeatAveragePng from "./w-seat-average.png";
import wSeatRoundPng from "./w-seat-round.png";
import wHipsNarrowPng from "./w-hips-narrow.png";
import wHipsAveragePng from "./w-hips-average.png";
import wHipsFullPng from "./w-hips-full.png";

import mChestNarrowPng from "./m-chest-narrow.png";
import mChestAveragePng from "./m-chest-average.png";
import mChestBroadPng from "./m-chest-broad.png";
import mStomachFlatPng from "./m-stomach-flat.png";
import mStomachAveragePng from "./m-stomach-average.png";
import mStomachRoundPng from "./m-stomach-round.png";
import mSeatFlatPng from "./m-seat-flat.png";
import mSeatAveragePng from "./m-seat-average.png";
import mSeatFullPng from "./m-seat-full.png";

export const BODY_IMAGES = {
	female: {
		stomach: {
			flat: wStomachFlatPng,
			average: wStomachAveragePng,
			round: wStomachRoundPng,
		},
		seat: {
			narrow: wSeatFlatPng,
			average: wSeatAveragePng,
			full: wSeatRoundPng,
		},
		hips: {
			narrow: wHipsNarrowPng,
			average: wHipsAveragePng,
			full: wHipsFullPng,
		},
	},
	male: {
		chest: {
			narrow: mChestNarrowPng,
			average: mChestAveragePng,
			broad: mChestBroadPng,
		},
		stomach: {
			flat: mStomachFlatPng,
			average: mStomachAveragePng,
			round: mStomachRoundPng,
		},
		seat: {
			narrow: mSeatFlatPng,
			average: mSeatAveragePng,
			full: mSeatFullPng,
		},
	},
} as const;
